export const modifierKeys = (platform: string): KeyModifier => {
  const isMac = platform === 'MacOS' || platform === 'iOS';

  return {
    platform,
    modifiers: {
      primary: isMac ? 'Meta' : 'Ctrl',
      secondary: isMac ? 'Ctrl' : 'Alt',
      shift: 'Shift',
      alt: 'Alt',
      meta: 'Meta',
      control: 'Ctrl',
    },
  };
};

import { KeyModifier, ModificationKey } from '@core/interfaces/key-modifier.interface';
import { iOSPlatforms, MacOSPlatforms, WindowsPlatforms } from '@features/applications/enums/platforms.enum';

export function detectOS(window: Window): string | null {
  const userAgent = window.navigator.userAgent,
    platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = Object.values<string>(MacOSPlatforms),
    windowsPlatforms = Object.values<string>(WindowsPlatforms),
    iosPlatforms = Object.values<string>(iOSPlatforms);
  let os: string | null = null;

  switch (true) {
    case macosPlatforms.indexOf(platform) !== -1:
      os = 'MacOS';
      break;
    case iosPlatforms.indexOf(platform) !== -1:
      os = 'iOS';
      break;
    case windowsPlatforms.indexOf(platform) !== -1:
      os = 'Windows';
      break;
    case /Android/.test(userAgent):
      os = 'Android';
      break;
    case !os && /Linux/.test(platform):
      os = 'Linux';
      break;
    default:
      break;
  }

  return os;
}

export function keyMatches(
  event: KeyboardEvent,
  matcher: 'code' | 'key',
  modificationKey: ModificationKey,
  key: string,
): boolean {
  const matches = event[matcher] === key && event[`${modificationKey.toLowerCase()}Key`];

  return matches;
}
